"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDrawMarkers = void 0;
var _react = require("react");
var MapConstants = _interopRequireWildcard(require("../constants"));
var TYPES = _interopRequireWildcard(require("../interfaces"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var createDomMarker = function createDomMarker(markerConfig) {
  var _markerConfig$options, _markerConfig$options2;
  if ((_markerConfig$options = markerConfig.options) !== null && _markerConfig$options !== void 0 && (_markerConfig$options2 = _markerConfig$options.icon) !== null && _markerConfig$options2 !== void 0 && _markerConfig$options2.element) {
    var domIcon = new H.map.DomIcon(markerConfig.options.icon.element(), {});
    var newMarker = new H.map.DomMarker(markerConfig.position, {
      icon: domIcon
    });
    return newMarker;
  }
  return null;
};
var createDomDraggableMarker = function createDomDraggableMarker(markerConfig) {
  console.warn("handleDomDraggableMarker not implemented.");
  return null;
};
var createDraggableMarker = function createDraggableMarker(markerConfig) {
  console.warn("handleDraggableMarker not implemented.");
  return null;
};
var createDefaultMarker = function createDefaultMarker(markerConfig) {
  if (markerConfig.options && markerConfig.options.icon) {
    var size = markerConfig.options.icon.size ? markerConfig.options.icon.size : MapConstants.smallIconSize;
    if (markerConfig.options.icon.iconSrc) {
      var iconElement = document.createElement('img');
      iconElement.src = markerConfig.options.icon.iconSrc;
      var icon = new H.map.Icon(iconElement, {
        crossOrigin: markerConfig.options.icon.crossOrigin || false,
        size: size
      });
      var newMarker = new H.map.Marker(markerConfig.position, {
        icon: icon
      });
      return newMarker;
    }
  }
  return null;
};
var createMarkerByType = function createMarkerByType(markerConfig) {
  switch (markerConfig.type) {
    case TYPES.EHereMapMarkerType.Dom:
      return createDomMarker(markerConfig);
    case TYPES.EHereMapMarkerType.DomDraggable:
      return createDomDraggableMarker(markerConfig);
    case TYPES.EHereMapMarkerType.Draggable:
      return createDraggableMarker(markerConfig);
    default:
      return createDefaultMarker(markerConfig);
  }
};

// Helper function for useDrawMarkers
function handleMarkersProp(map, markers) {
  var markerGroup = new H.map.Group();

  // sanity and null checks, return if no map or markers
  if (!map || !markers) return markerGroup;

  // do logic to all arrays of markers

  /* 
      *note* that the markers prop is currently implemented as [][] with a mind to
      supporting EITHER different marker types, or marker PRIORITY via array order
      ex: higher priority markers being in higher indexes would ensure they are
      drawn over the markers in lower indexes, preserving visual precedence
   */

  markers.forEach(function (markersArray) {
    if (markersArray && markersArray.length !== 0) {
      // if this array exists and is not empty, do logic to all markers
      markersArray.forEach(function (markerConfig) {
        if (markerConfig) {
          var marker;
          // create marker
          marker = createMarkerByType(markerConfig);
          // add marker to markerGroup for tracking
          marker && markerGroup.addObject(marker);
        }
        return markerGroup;
      });
    }
    return markerGroup;
  });
  return markerGroup;
}

// This effect handles drawing markers to map (markers array is received as prop to HereMap)
var useDrawMarkers = function useDrawMarkers(map, newMarkers) {
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    markerGroup = _useState2[0],
    setMarkerGroup = _useState2[1];
  (0, _react.useEffect)(function () {
    if (map) {
      var currentMarkerList = markerGroup;
      // ensure map exists before trying to add markers
      currentMarkerList && map.removeObjects(currentMarkerList);
      // ensure there are -some- markers before trying to add markers
      if (newMarkers && newMarkers.length > 0) {
        // clear the current contents of markerGroup
        var newMarkerGroup = handleMarkersProp(map, newMarkers);
        var objectList = newMarkerGroup.getObjects();
        newMarkerGroup && map.addObjects(objectList);
        setMarkerGroup(objectList);
      }
    }
  }, [map, newMarkers]);
  return markerGroup;
};
exports.useDrawMarkers = useDrawMarkers;